import NumberUnit from '@exodus/currency'

export const createCustomFeesApi = ({ baseAsset }) => {
  const Gwei = baseAsset.currency.units.Gwei
  return {
    getRecommendedMinMaxFeeUnitPrices: ({ feeData }) => {
      const { gasPrice, gasPriceMultiplier, gasPriceMinimumRate, gasPriceMaximumRate } = feeData

      const calculateFeeUnitPrice = (
        feeUnitPrice,
        multiplier = 1,
        toAdd = baseAsset.currency.ZERO
      ) => feeUnitPrice.to('Gwei').mul(multiplier).add(toAdd).toNumber(Gwei)

      return {
        recommended: calculateFeeUnitPrice(gasPrice, gasPriceMultiplier),
        min: calculateFeeUnitPrice(gasPrice, gasPriceMinimumRate * gasPriceMultiplier),
        max: calculateFeeUnitPrice(gasPrice, gasPriceMaximumRate * gasPriceMultiplier),
      }
    },
    unit: 'gwei/gas',
    feeUnitPriceToNumber: (feeNumberUnit) => feeNumberUnit.toNumber(Gwei),
    numberToFeeUnitPrice: (value) => new NumberUnit(value, Gwei),
    isEnabled: ({ feeData }) => Boolean(feeData.rbfEnabled),
  }
}
